import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getWarningLetters,
  getWarningLetterById,
  getWarningLettersByPKS,
  getWarningLettersByMitra,
  createWarningLetter,
  updateWarningLetter,
  deleteWarningLetter,
  issueWarningLetter,
  deliverWarningLetter,
  acknowledgeWarningLetter,
  resolveWarningLetter,
  escalateWarningLetter,
} from "libs/api/warning_letter";

const thunk = (name, fn) =>
  createAsyncThunk(name, async (args = {}) => {
    const { cbPending, cbFulfilled, cbRejected, cbFinally, ...rest } = args;
    try {
      typeof cbPending === "function" && cbPending();
      const response = await fn(rest);
      typeof cbFulfilled === "function" && cbFulfilled(response);
      return response?.data;
    } catch (error) {
      if (error.response) {
        typeof cbRejected === "function" && cbRejected(error.response);
        throw JSON.stringify(error.response.data);
      } else {
        typeof cbRejected === "function" && cbRejected(error);
        throw JSON.stringify({ message: error.message });
      }
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  });

export const getWarningLettersThunk = thunk(
  "warningLetter/getAll",
  ({ queryParams = "" }) => getWarningLetters(queryParams),
);

export const getWarningLetterByIdThunk = thunk(
  "warningLetter/getById",
  ({ id }) => getWarningLetterById(id),
);

export const getWarningLettersByPKSThunk = thunk(
  "warningLetter/getByPKS",
  ({ pks_id }) => getWarningLettersByPKS(pks_id),
);

export const getWarningLettersByMitraThunk = thunk(
  "warningLetter/getByMitra",
  ({ mitra_id }) => getWarningLettersByMitra(mitra_id),
);

export const createWarningLetterThunk = thunk(
  "warningLetter/create",
  ({ body, accessToken }) => createWarningLetter(body, accessToken),
);

export const updateWarningLetterThunk = thunk(
  "warningLetter/update",
  ({ id, body, accessToken }) => updateWarningLetter(id, body, accessToken),
);

export const deleteWarningLetterThunk = thunk(
  "warningLetter/delete",
  ({ id }) => deleteWarningLetter(id),
);

export const issueWarningLetterThunk = thunk(
  "warningLetter/issue",
  ({ id, body }) => issueWarningLetter(id, body),
);

export const deliverWarningLetterThunk = thunk(
  "warningLetter/deliver",
  ({ id, body }) => deliverWarningLetter(id, body),
);

export const acknowledgeWarningLetterThunk = thunk(
  "warningLetter/acknowledge",
  ({ id, body }) => acknowledgeWarningLetter(id, body),
);

export const resolveWarningLetterThunk = thunk(
  "warningLetter/resolve",
  ({ id, body }) => resolveWarningLetter(id, body),
);

export const escalateWarningLetterThunk = thunk(
  "warningLetter/escalate",
  ({ id }) => escalateWarningLetter(id),
);
